<template>
  <div>
    <span v-if="device.bateryStatus > 0 && device.bateryStatus < 255">
      <span
        v-if="Math.round((device.bateryStatus / 254) * 100, 2) >= 40"
        class="text-success"
      >
        {{ Math.round((device.bateryStatus / 254) * 100, 2) }}
        %
      </span>
      <span
        v-if="
          Math.round((device.bateryStatus / 254) * 100, 2) < 40 &&
            Math.round((device.bateryStatus / 254) * 100, 2) >= 20
        "
        class="text-warning"
      >
        {{ Math.round((device.bateryStatus / 254) * 100, 2) }}
        %
      </span>
      <span
        v-else-if="
          Math.round((device.bateryStatus / 254) * 100, 2) < 20 &&
            Math.round((device.bateryStatus / 254) * 100, 2) >= 0.1
        "
        class="text-danger"
      >
        {{ Math.round((device.bateryStatus / 254) * 100, 2) }}%
      </span>
    </span>
    <span v-if="device.bateryStatus == 0">
      AC
    </span>
    <span v-if="device.bateryStatus == 255">
      N/A
    </span>
    <span v-if="device.bateryStatus == null">
      ?
    </span>
  </div>
</template>

<script>
export default {
  props: {
    device: Object
  },
  data() {
    return {};
  },
  mounted() {}
};
</script>

<style lang="scss" scoped></style>
